/* eslint-disable import/prefer-default-export */
import dayjs from 'dayjs';

const advancedFormat = require('dayjs/plugin/advancedFormat');

dayjs.extend(advancedFormat);

export const getFormattedDate = (date, format = null) => {
    if (!dayjs(date).isValid()) {
        return null;
    }

    if (format) {
        return dayjs(date).format(format);
    }

    return dayjs(date).format('Do MMM YYYY');
};

export const getDayOfWeek = date => getFormattedDate(date, 'dddd');

export const getFormattedTime = (date, format = 'h:mma') => {
    if (!dayjs(date).isValid()) {
        return null;
    }

    return dayjs(date).format(format);
};

export const getDayOfTheMonth = date => getFormattedDate(date, 'Do');

export const getTheMonth = date => getFormattedDate(date, 'MMMM');
